import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CredentialsService } from '@core/services/credentials.service';
import { Observable } from 'rxjs';
import { ComparativeChartItem, LandingData } from './dashboard.types';
import { TranslateService } from '@ngx-translate/core';
import { NumberTranslatePipe } from '@app/@shared/pipes/number-translate/number-translate.pipe';

const routes = {
  getLanding: (lat: number, lng: number) =>
    `/org/sgs/landing?latitude=${lat}&longitude=${lng}`,
  getComparativeChart: () => {
    return `/org/sgs/bags-analytics/comparative/chart`;
  },
};

export const enum LuggageStage {
  Pickup = 1,
  Checkin = 2,
  Transit = 3,
  Checkout = 4,
  Delivery = 5,
}

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  constructor(
    private credentialsService: CredentialsService,
    private httpClient: HttpClient,
    private translateService: TranslateService,
    private numberTranslatePipe: NumberTranslatePipe,
  ) {}

  getLanding(latitude: number, longitude: number): Observable<LandingData> {
    return this.httpClient.get<LandingData>(
      routes.getLanding(latitude, longitude),
      {
        headers: {
          Authorization: `Bearer ${this.credentialsService.credentials.token}`,
          'Accept-Language': 'en',
        },
      },
    );
  }
  getComparativeChart(): Observable<ComparativeChartItem[]> {
    return this.httpClient.get<ComparativeChartItem[]>(
      routes.getComparativeChart(),
      {
        headers: new HttpHeaders({
          Authorization: `Bearer ${this.credentialsService.credentials.token}`,
        }),
      },
    );
  }

  formatTime(minutes: number = 0): string {
    if (minutes < 60) {
      return `${this.numberTranslatePipe.transform(
        Math.floor(minutes),
      )} ${this.translateService.instant('minute(s)')}`;
    } else if (minutes < 1440) {
      // 60 * 24
      return `${this.numberTranslatePipe.transform(
        Math.floor(minutes / 60),
      )} ${this.translateService.instant('hour(s)')}`;
    } else if (minutes < 525600) {
      // 60 * 24 * 365
      return `${this.numberTranslatePipe.transform(
        Math.floor(minutes / 1440),
      )} ${this.translateService.instant('day(s)')}`;
    } else {
      return `${this.numberTranslatePipe.transform(
        (minutes / 525600).toFixed(1),
      )} ${this.translateService.instant('year(s)')}`;
    }
  }
}
